module.exports = __webpack_public_path__ + "img/bmna.933ef7df.jpg";